import { useContext } from 'react';

import { ensureDefined } from '@e-socna/utils';

import { AccountingContext } from '..';

export const useAccountingContext = () => {
  const { context } = ensureDefined(
    {
      context: useContext(AccountingContext),
    },
    'useAccountingContext must be used within AccountingContextProvider',
  );

  return context;
};
